import { addDays, format } from 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';
import { getExpandedLabel, getSenderName } from 'utilities/huggg';
import styles from './huggg-list-button.module.scss';

const HugggListItem = (props) => {
  const { huggg, onClick } = props;

  const renderProductImage = () => (
    <div
      style={{
        backgroundImage: `url(${huggg.purchase.image_url})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        width: '100%',
        height: '150px',
        marginBottom: '20px',
      }}
      className={styles.imageRedesign}
    />
  );

  return (
    <button
      onClick={(event) => onClick && onClick(event, huggg)}
      className={styles.huggg}
    >
      {renderProductImage()}

      <span className={styles.hugggText}>
        <strong className={styles.productName}>
          {getExpandedLabel(huggg)}
        </strong>
        <span className={styles.senderName}>from {getSenderName(huggg)}</span>
      </span>

      <span className={styles.hugggMeta}>
        <span className={styles.expires} title="expiration date">
          expires on
          <br />
          {format(addDays(new Date(huggg.expiry_date), 1), 'dd/MM/yyyy')}
        </span>
      </span>
    </button>
  );
};

HugggListItem.propTypes = {
  huggg: PropTypes.object.isRequired,
  onClick: PropTypes.func,
};

export default HugggListItem;
